import { createContext } from "react";

const EventMasterDataContext = createContext({});

export default EventMasterDataContext;
